import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * Reusable empty-state block for admin lists/tables.
 * Keeps visual language consistent across the app.
 */
export const EmptyState = ({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  description = '',
  action = null,
  className = '',
  testid,
}) => (
  <div data-testid={testid} className={`px-6 py-12 flex flex-col items-center text-center ${className}`}>
    <div className="inline-flex w-14 h-14 items-center justify-center rounded-2xl bg-[var(--pg-admin-accent-soft)] text-[var(--pg-admin-accent)] mb-4">
      <Icon className="w-7 h-7" />
    </div>
    <div className="font-display text-xl text-white leading-tight">{title}</div>
    {description && <p className="mt-1.5 text-sm text-white/60 max-w-md">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
